// extracted by css-extract-rspack-plugin
export default {"root":"UYElDV","button":"fly9YX","is-active":"MgS06W","isActive":"MgS06W"};